/**
 * Mirrors the Route names + Event types tables in
 * `iv3api/docs/NOTIFICATION_SYSTEM.md`. Update both sides when adding entries.
 */
import type { BroadcastEnv, BroadcastEnvInfo } from "src/types/broadcasts";

export interface NavigationTargetOption {
  value: string;
  label: string;
}

export const NAVIGATION_TARGETS: NavigationTargetOption[] = [
  { value: "HOME_TAB", label: "Home tab" },
  { value: "MAP_SEARCH", label: "Map / search" },
  { value: "TASKS_TODO", label: "My Vues — To Do" },
  { value: "TASKS_IN_REVIEW", label: "My Vues — In Review" },
  { value: "TASKS_ACCEPTED", label: "My Vues — Accepted" },
  { value: "TASKS_CANCELLED", label: "My Vues — Cancelled" },
  { value: "TASKS_FAILED", label: "My Vues — Failed" },
  { value: "VUE_DETAILS", label: "Vue detail page" },
  { value: "PROFILE", label: "Profile" },
  { value: "ACCOUNT", label: "Account" },
  { value: "INTERNAL_NETWORK", label: "Internal network" },
  { value: "MORE_TAB", label: "More tab" },
  { value: "NOTIFICATION_PREFERENCES", label: "Notification preferences" },
  { value: "QUALIFICATION", label: "Qualification flow" },
  { value: "SETTINGS", label: "Settings" },
];

export interface NotificationEventOption {
  value: string;
  label: string;
}

export const NOTIFICATION_EVENTS: NotificationEventOption[] = [
  { value: "VUE_CANCELLED", label: "Vue cancelled" },
  { value: "VUE_APPROVED", label: "Vue approved" },
  { value: "SENT_BACK", label: "Sent back" },
  { value: "VUE_UNCLAIMED", label: "Vue unclaimed" },
  { value: "VUE_FAILED", label: "Vue failed" },
  { value: "NEW_VUE_AVAILABLE", label: "New Vue available" },
  { value: "VUE_PAYOUT_INCREASED", label: "Payout increased" },
  { value: "USER_STATUS_CHANGED", label: "User status changed" },
];

export const BROADCAST_ENVS: BroadcastEnvInfo[] = [
  {
    value: "local",
    label: "Local",
    baseUrl: process.env.REACT_APP_DOMAIN_LOCAL || "",
    tone: "neutral",
  },
  {
    value: "sandbox",
    label: "Sandbox",
    baseUrl: process.env.REACT_APP_DOMAIN_SANDBOX || "",
    tone: "neutral",
  },
  {
    value: "staging",
    label: "Staging",
    baseUrl: process.env.REACT_APP_DOMAIN_STAGING || "",
    tone: "neutral",
  },
  {
    value: "preprod",
    label: "Pre-prod",
    baseUrl: process.env.REACT_APP_DOMAIN_PREPROD || "",
    tone: "warn",
  },
  {
    value: "prod",
    label: "Production",
    baseUrl: process.env.REACT_APP_DOMAIN_PROD || "",
    tone: "danger",
  },
];

export function getBroadcastEnvInfo(env: BroadcastEnv): BroadcastEnvInfo {
  const match = BROADCAST_ENVS.find((e) => e.value === env);
  if (!match) throw new Error(`Unknown broadcast env: ${env}`);
  return match;
}
